import { render, staticRenderFns } from "./StatisticsSlider.vue?vue&type=template&id=51f11db9&"
import script from "./StatisticsSlider.vue?vue&type=script&lang=js&"
export * from "./StatisticsSlider.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports